import { render } from "./modal.vue?vue&type=template&id=775718bd"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
script.render = render

export default script